import { render, staticRenderFns } from "./ModalIni.vue?vue&type=template&id=b90dc310&scoped=true&"
import script from "./ModalIni.vue?vue&type=script&lang=js&"
export * from "./ModalIni.vue?vue&type=script&lang=js&"
import style0 from "./ModalIni.vue?vue&type=style&index=0&id=b90dc310&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90dc310",
  null
  
)

export default component.exports